import Hero from "./Components/Hero";
import Nav from "./Components/Nav";
function App() {
  return (
    <>
      <Hero />
      <Nav />
    </>
  );
}

export default App;
